import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { th } from 'style/theme';
import { motion } from 'framer-motion';
import { ReactComponent as DiceIcon } from 'products/global/assets/img/icons/av-dice.svg';
import { sizes } from 'style';
import Avatar from '../Avatar';

const PreviewWrapper = styled(motion.div)`
  grid-area: preview;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  @media ${sizes.desktop} {
    padding: 0 20px;
  }
`;

const AvatarWrapper = styled(motion.div)`
  overflow-y: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 55px;
  margin-top: auto;

  @media ${sizes.desktop} {
    padding-top: 28%;
  }
`;

const StyledAvatar = styled(Avatar)`
  width: 135px;
  margin-bottom: 30px;

  @media ${sizes.desktop} {
    width: 59%;
    margin-bottom: 9%;
  }
`;

const Name = styled.div`
  z-index: 1;
  position: relative;
  background: white;
  border-radius: 8px;
  width: 75%;
  padding: 6px 0;
  font-size: 24px;
  font-weight: 600;
  display: none;
  align-items: center;
  justify-content: center;
  box-shadow: ${th('shadows.small')};

  @media ${sizes.desktop} {
    display: flex;
  }
`;

const RandomizeButton = styled.div`
  user-select: none;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 12px;
  left: 12px;

  > svg {
    width: 20px;
    margin-right: 4px;
  }

  @media ${sizes.desktop} {
    position: relative;
    margin-top: 24px;
    bottom: 0;
    left: 0;
    font-size: 16px;
  }
`;

const Preview = ({ config, randomize, isRandomizing, firstName }) => {
  return (
    <PreviewWrapper
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { delay: 0.1 } }}
    >
      <AvatarWrapper
        isRandomizing={isRandomizing}
        animate={isRandomizing ? { x: [-3, 3] } : { x: 0 }}
        transition={isRandomizing && { duration: 0.05, yoyo: Infinity }}
      >
        <StyledAvatar config={config} />
      </AvatarWrapper>
      <Name>{firstName}</Name>
      <RandomizeButton onClick={randomize} type="button">
        <DiceIcon /> Randomize
      </RandomizeButton>
    </PreviewWrapper>
  );
};

Preview.propTypes = {
  config: PropTypes.object,
  randomize: PropTypes.func,
  firstName: PropTypes.string,
  isRandomizing: PropTypes.bool
};

export default Preview;
